import React, { useEffect } from "react";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const animationVariants = {
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 1.8
        }
    },
    hidden:{
        opacity: 0,
        scale: 0.7,
    }
}

export const FunSlide = ({children}) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();

    useEffect(() => {
        if (inView) {
            controls.start('visible');
        }
    }, [controls, inView])

    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial='hidden'
            variants={animationVariants}
            className='v-t-anim'
        >
            {children}
        </motion.div>
    )
}